<div class="d-flex justify-content-between align-items-start mb-2">
  <div class="d-flex align-items-center gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="downloadTemplate()">
      <i class="fas fa-download mr-1"></i>
      {{ 'DOWNLOAD_TEMPLATE' | translate }}
    </button>
    <label class="btn btn-outline-primary mb-0">
      <i class="fas fa-upload mr-1"></i>
      {{ 'IMPORT_EXCEL' | translate }}
      <input #importFile type="file" class="d-none" accept=".xlsx" [disabled]="importLoading" (change)="importReplenishmentProducts(importFile)" />
    </label>
    <i *ngIf="importLoading" class="fa fa-spinner fa-spin fa-lg"></i>
  </div>
  <div class="mb-2">
    <span style="font-size: 12px" class="mr-2" translate>ADD_CUSTOMER</span>
    <label class="expandableAddCustomer">
      <input
        id="customerid"
        type="text"
        class="form-control"
        [resultFormatter]="formatterCustomer"
        [ngbTypeahead]="searchCustomers"
        (selectItem)="onSelectCustomer($event)"
      />
      <i class="far fa-plus"></i>
    </label>
  </div>
</div>

<div *ngIf="importResult" class="alert" [ngClass]="importResult.failed > 0 ? 'alert-warning' : 'alert-success'">
  <span>{{ 'REPLENISHMENT_IMPORT_IMPORTED' | translate: { count: importResult.imported } }}</span>
  <span *ngIf="importResult.failed > 0" class="ml-2">{{ 'REPLENISHMENT_IMPORT_FAILED' | translate: { count: importResult.failed } }}</span>
  <ul *ngIf="importResult.errors?.length > 0" class="mt-2 mb-0">
    <li *ngFor="let error of importResult.errors">
      {{ 'ROW' | translate }} {{ error.rowNumber }}<span *ngIf="error.productId"> ({{ error.productId }})</span>: {{ error.error }}
    </li>
  </ul>
</div>

<div *ngIf="data && loaded; else loading" class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>CUSTOMER</th>
        <th style="width: 150px" class="text-right" translate>ACTIVE</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data">
        <td>
          <a [routerLink]="['/replenishment/', item.customerId]">
            <span class="customer-id">{{ item.customerId }}</span> <br />
            <span class="customer-name" *ngIf="keyedCustomers[item.customerId]">{{
                keyedCustomers[item.customerId].name
              }}</span>
          </a>
        </td>

        <td class="text-right toggle-switch-column">
          <div class="gung-toggle-switch">
            <label class="switch">
              <input
                id="activeState"
                name="activeState"
                type="checkbox"
                #activeStateInput
                [checked]="item.active"
                (change)="changeActiveState(item, $event.target.checked)"
              />
              <span class="slider round bg-primary"></span>
            </label>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
  LOADING...
</ng-template>
